import axios from "axios";

export interface Dish {
  id?: string;
  companyId: string;
  companyLocationId: string;
  name: string;
  isDeleted?: boolean;
}

export async function addDish(dish: Dish) {
  return axios.post<Dish>(`/Disheses/adddishes`, dish).then((res) => res.data);
}

export async function getallDishesByCompanyId(CompanyId: string) {
  return axios
    .get<Dish[]>(`/Disheses/getalldishesesbycompanyid`, {
      params: { CompanyId },
    })
    .then((res) => res.data.filter((dish) => !dish.isDeleted));
}

export async function updateDish(dish: Dish) {
  return axios
    .put<Dish>(`/Disheses/updatedishes`, dish)
    .then((res) => res.data);
}

export function deleteDish(id: string) {
  return axios
    .delete(`/Disheses/deletedishes`, { data: { id } })
    .then((response) => response.data);
}
